import { render, staticRenderFns } from "./CodeDelete.vue?vue&type=template&id=165f0700&scoped=true"
import script from "./CodeDelete.vue?vue&type=script&lang=js"
export * from "./CodeDelete.vue?vue&type=script&lang=js"
import style0 from "./CodeDelete.vue?vue&type=style&index=0&id=165f0700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f0700",
  null
  
)

export default component.exports